<app-info-banner
  variant="info"
  iconUrl="/public/svgs/info.svg"
  title="app.components.parentAiAssistant.verificationBannerTitle"
  message="app.components.parentAiAssistant.verificationBanner"
  [translateTitle]="true"
  [translateMessage]="true"
  ariaLabel="app.components.parentAiAssistant.verificationBannerTitle"
  [translateAriaLabel]="true"
/>
